// @ts-check

import React, { createContext, useState } from "react"
import { DateTime } from "luxon"
import { UNIFIEDDATE_VALUES } from "../consts/CompoundRangeDatePicker"
import useDefaultableState from "../hooks/useDefaultableState.js"

/** @typedef {import("./IndividualReportFilters.context.types.d.ts").context} context */

export const IndividualReportFiltersContext = createContext(
  /** @type {context} */
  ({
    teamMember: {
      value: undefined,
      setValue: () => {},
      revert: () => {},
      setDefaultValue: () => {},
      resetWith: () => {},
      defaultValue: undefined,
    },
    period: UNIFIEDDATE_VALUES.SINGLEWEEK,
    setPeriod: () => {},
    dateRange: [
      DateTime.local().startOf("week"),
      DateTime.local().endOf("week"),
    ],
    setDateRange: () => {},
  })
)

export const IndividualReportFiltersContextProvider = ({ children }) => {
  const teamMember = useDefaultableState(
    /** @type {context["teamMember"]["value"]} */
    (undefined)
  )
  const [period, setPeriod] = useState(
    /** @type {context["period"]} */ (UNIFIEDDATE_VALUES.SINGLEWEEK)
  )
  const [dateRange, setDateRange] = useState(
    /** @type {context["dateRange"]} */ ([
      DateTime.local().startOf("week"),
      DateTime.local().endOf("week"),
    ])
  )

  return (
    <IndividualReportFiltersContext.Provider
      value={{
        teamMember,
        period,
        setPeriod,
        dateRange,
        setDateRange,
      }}
    >
      {children}
    </IndividualReportFiltersContext.Provider>
  )
}
